/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Xmlid7308IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Xmlid7308Icon(props: Xmlid7308IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 115 526"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M104.241 517.316c-2.185 6.978-9.905 10.554-16.632 7.68l-12.196-5.217c.45-.756.807-1.589 1.086-2.464 9.508-30.403 26.245-109.206-24.815-182.009-32.628-46.545-21.439-76.208-4.502-121.097 6.607-17.507 14.09-37.356 18.816-59.337C80.485 87.578 29.053 33.366 0 8.855l2.184-3.31C6.157-.469 14.393-1.819 20.061 2.617c26.232 20.445 89.555 78.498 73.69 152.255-4.727 21.981-12.222 41.831-18.83 59.337-16.936 44.889-28.125 74.551 4.517 121.097 51.061 72.803 34.31 151.606 24.803 182.009z"
        }
      ></path>
    </svg>
  );
}

export default Xmlid7308Icon;
/* prettier-ignore-end */
